// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__1fU3w","item":"carousel_item__1NI5r"};